export default "__VITE_ASSET__Dfd_ZcsR__"